const KEY_PREFIX = 'upload_session_';
export const UPLOAD_SESSION_TTL = 4 * 60 * 60 * 1000;

export interface StoredUploadSession {
  uploadId: string;
  key: string;
  bucket: string;
  publicUrl: string;
  partSize: number;
  partsCount: number;
  fileSize: number;
  updatedAt: number;
}

export function uploadFingerprint(userId: number, file: File, asPeerId = 0) {
  return `${KEY_PREFIX}${userId}_${asPeerId}_${file.name}_${file.size}_${file.lastModified}`;
}

export function saveUploadSession(
  fingerprint: string,
  session: Omit<StoredUploadSession, 'updatedAt'>,
) {
  try {
    localStorage.setItem(
      fingerprint,
      JSON.stringify({ ...session, updatedAt: Date.now() }),
    );
  } catch {}
}

export function touchUploadSession(fingerprint: string) {
  const session = getUploadSession(fingerprint);
  if (session) {
    saveUploadSession(fingerprint, session);
  }
}

export function getUploadSession(fingerprint: string): StoredUploadSession | null {
  try {
    const raw = localStorage.getItem(fingerprint);
    if (!raw) return null;
    const session: StoredUploadSession = JSON.parse(raw);
    if (!session?.uploadId || Date.now() - session.updatedAt > UPLOAD_SESSION_TTL) {
      localStorage.removeItem(fingerprint);
      return null;
    }
    return session;
  } catch {
    return null;
  }
}

export function removeUploadSession(fingerprint: string) {
  try {
    localStorage.removeItem(fingerprint);
  } catch {}
}
